import axios from 'axios'

const noAuthApiAxios = axios.create({
  baseURL: `${process.env.apiServerOrigin}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
  },
})

noAuthApiAxios.interceptors.request.use(
  (config) => {
    // no modifications to headers
    return config
  },
  (error) => Promise.reject(error)
)

noAuthApiAxios.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(error.response)
)

export default noAuthApiAxios
